import { ApolloQueryResult, ObservableQuery, OperationVariables } from '@apollo/client'
import { Observable, Subscriber } from 'rxjs'

/** Adapt ObservableQuery from from Apollo to RxJS */
export const fromObservableQuery = <T, V extends OperationVariables>(
  obsQuery: ObservableQuery<T, V>,
): Observable<ApolloQueryResult<T>> =>
  new Observable<ApolloQueryResult<T>>((subscriber: Subscriber<ApolloQueryResult<T>>) =>
    obsQuery.subscribe(subscriber),
  )
